module.exports = __webpack_public_path__ + "img/phone-more.aca1d124.png";